import { Component, OnDestroy, OnInit } from '@angular/core'
import { faTrophy, faCheck } from '@fortawesome/free-solid-svg-icons'
import { finalize } from 'rxjs/operators'
import { formatHours } from '@shared/const/hours/hours-formatter.const'
import { Leaderboard } from '@shared/models/leaderboard.model'
import { LeaderboardService } from '@shared/services/leaderboard.service'
import { PublicPageTitleService } from '@public/app/services/public-page-title.service'
import { LoadingIndicatorService } from '@public/app/services/loading-indicator.service'

@Component({
  selector: 'app-leaderboard',
  templateUrl: './leaderboard.component.html',
  styleUrls: ['./leaderboard.component.scss'],
  standalone: false,
})
export class LeaderboardComponent implements OnInit, OnDestroy {
  leaderboard: Leaderboard | null = null
  hasError = false
  faTrophy = faTrophy
  faCheck = faCheck
  formatHours = formatHours

  constructor(
    private leaderboardService: LeaderboardService,
    private publicPageTitleService: PublicPageTitleService,
    private loadingIndicatorService: LoadingIndicatorService
  ) {}

  get showOwnRow(): boolean {
    return !!this.leaderboard?.me?.rank && !this.leaderboard.items.some(item => item.isMe)
  }

  ngOnInit(): void {
    this.publicPageTitleService.setPageTitle('Rangsor')
    this.load()
  }

  ngOnDestroy(): void {
    this.publicPageTitleService.clearPageTitle()
  }

  load(): void {
    this.hasError = false
    this.loadingIndicatorService.showLoading()
    this.leaderboardService
      .getLeaderboard()
      .pipe(finalize(() => this.loadingIndicatorService.hideLoading()))
      .subscribe({
        next: leaderboard => (this.leaderboard = leaderboard),
        error: () => (this.hasError = true),
      })
  }
}
